import type { CustomCellEditorProps } from 'ag-grid-react';

import { useFormattedNumberInput } from '@mint-lib/formatting-hooks';
import { useFlags } from '@mint-lib/routing-context';
import { Input } from '@mint-lib/tw-components';

import { useStartFromEventKey } from '../hooks/useStartFromEventKey.js';

export interface NumberEditorProps extends CustomCellEditorProps {
  maxDecimals?: number;
  min?: number;
}

export const NumberEditor = (props: NumberEditorProps) => {
  const { onValueChange, value, eventKey, maxDecimals, min } = props;

  const ff = useFlags('@mint/arm', ['decimalFormattingOnCellEdit']);

  const startValue = useStartFromEventKey(eventKey, value, onValueChange);

  const inputProps = useFormattedNumberInput({
    onChange: onValueChange,
    value: startValue === '' ? null : startValue,
    autoFocus: true,
    size: 'small',
    maxDecimals,
    restFormatProps: { min },
    // TODO(PDT-102307): remove this prop together with the
    // `decimalFormattingOnCellEdit` feature flag.
    preserveRawValueOnEdit: ff.decimalFormattingOnCellEdit.enabled,
  });

  return (
    <Input
      className="w-full border-none focus:outline-none"
      aria-label="number-editor"
      data-dd-action-name="Grid cell: edit number"
      {...inputProps}
    />
  );
};
